// SONIO brand badges: dark text on a light tint with a coloured dot
// (green text on white is unreadable, so green only appears as the dot/fill).
const PASS =
  "bg-[#6ECF8926] border-transparent text-[#252525] font-semibold before:content-[''] before:mr-1.5 before:inline-block before:h-[7px] before:w-[7px] before:rounded-full before:bg-[#6ECF89] hover:bg-[#6ECF8926]";
const FAIL =
  "bg-[#B215151F] border-transparent text-[#252525] font-semibold before:content-[''] before:mr-1.5 before:inline-block before:h-[7px] before:w-[7px] before:rounded-full before:bg-[#B21515] hover:bg-[#B215151F]";
const REVIEW =
  "bg-[#E9940026] border-transparent text-[#252525] font-semibold before:content-[''] before:mr-1.5 before:inline-block before:h-[7px] before:w-[7px] before:rounded-full before:bg-[#E99400] hover:bg-[#E9940026]";
const PENDING =
  "bg-[#5B6B801F] border-transparent text-[#252525] font-semibold before:content-[''] before:mr-1.5 before:inline-block before:h-[7px] before:w-[7px] before:rounded-full before:bg-[#5B6B80] hover:bg-[#5B6B801F]";
const NEUTRAL =
  "bg-[#8A97A81F] border-transparent text-[#252525] font-semibold before:content-[''] before:mr-1.5 before:inline-block before:h-[7px] before:w-[7px] before:rounded-full before:bg-[#8A97A8] hover:bg-[#8A97A81F]";

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'STARTED':
      return NEUTRAL;
    case 'COMPLETED':
    case 'PASS':
      return PASS;
    case 'CANCELED':
    case 'FAIL':
    case 'UNSUPPORTED':
    case 'INVALID':
      return FAIL;
    case 'NEEDS_REVIEW':
      return REVIEW;
    case 'PENDING':
      return PENDING;
    default:
      return NEUTRAL;
  }
};

export const getResultColor = (result: string) => {
  switch (result) {
    case 'PENDING':
      return PENDING;
    case 'PASS':
      return PASS;
    case 'NEEDS_REVIEW':
      return REVIEW;
    case 'FAIL':
      return FAIL;
    default:
      return NEUTRAL;
  }
};
